import React, { useState, useEffect } from "react";

import './queue.css';

import SingleGrid from '../components/SingleGrid.js';

import { GetQueue, AddQueue } from '../components/LambdaApi.js';

import { Link } from 'react-router-dom'
import { useClient } from '../context/ClientContext.tsx';

import { useDialog } from "../hooks/useDialog";

const Queue = () => {

    const { confirm, alert, Dialog } = useDialog();

    document.documentElement.style.setProperty("--colWidthPct", "15%");

    const [apiResults, setApiResults] = useState([]);

    const [buttonText, setButtonText] = useState("Remove Row");

    const [removeCellButtonText, setRemoveCellButtonText] = useState("Remove Item");

    const [changeCellButtonText, setChangeCellButtonText] = useState("Update Item");

    const [gridApi1, setGridApi1] = useState(null);

    const [selectedItem, setSelectedItem] = useState(null);

    const [updateIDValue, setUpdateIDValue] = useState(null);

    const [showInput, setShowInput] = useState(false);

    //const numberOfQueueColumns = 5;
    //const [numberOfQueueColumns, setNumberOfQueueColumns] = useState(5);
    const [numberOfQueueColumns, setNumberOfQueueColumns] = useState(() => {
        const stored = localStorage.getItem('numberOfQueueColumns');
        return stored !== null ? Number(stored) : 5; // fallback default
    });


    const testMode = false;



    const refreshSeconds = 15;
    const refreshMilliseconds = refreshSeconds * 1000;

    const { name, organization } = useClient();

    var currentdate = new Date();

    const onCellFocused = (event) => {
        const row = event.api.getDisplayedRowAtIndex(event.rowIndex);
        //const cellValue = event.api.getCellValue({ rowNode: row, colKey: event.column.colId });
        const fullObject = row.data;
        //console.log('Focused cell value:', cellValue);
        //console.log('fullObject:', fullObject);
        //setSelectedItem(cellValue);
        setSelectedItem(fullObject);
        //alert("onCellFocused:".concat(cellValue));
    };


    function updateIDOnChange(event) {
        setUpdateIDValue(event.target.value);
    }

    /*
    function removeRow() {
        setButtonText("Removing...");
        var loopCount = 0;
        apiResults.some(element => {
            //if(element.QueueNum < numberOfQueueColumns){
            if (loopCount < numberOfQueueColumns) {
                //alert(element.UserID);
                deleteItem(element);
            }
            else {
                return true;
            }
            loopCount = loopCount + 1;
        })

        setSelectedItem("");

        //need a delay as the last record is not updated to DB yet.
        //reload data
        setTimeout(() => {
            GetQueue(organization).then(data => processData(data));
            setButtonText("Remove Row");
        }, 1500); // 1500 milliseconds = 1.5 second
    }
    */

    async function removeRow() {
        setButtonText("Removing...");

        const promises = apiResults.slice(0, numberOfQueueColumns)
            .map(element => deleteItem(element));

        await Promise.all(promises); // wait until all updates finish

        setSelectedItem("");

        const data = await GetQueue(organization);
        processData(data);
        setButtonText("Remove Row");
    }


    function removeCell() {

        if (!selectedItem) {
            alert("An item must be selected first.");
            return;
        }

        setRemoveCellButtonText("Removing...");

        apiResults.some(element => {
            if (element.StudentID === selectedItem.StudentID
                && element.InsertDtm === selectedItem.InsertDtm
            ) {
                //alert("Remove:" + element.StudentID);
                deleteItem(element);
                return true;
            }
        })

        setSelectedItem(null);

        //need a delay as the last record is not updated to DB yet.
        //reload data
        setTimeout(() => {
            GetQueue(organization).then(data => processData(data));
            setRemoveCellButtonText("Remove Item");
        }, 1000); // 1500 milliseconds = 1.5 second

    }

    function onNumberColumnsChanged(event) {
        const value = Number(event.target.value);
        setNumberOfQueueColumns(value);
        localStorage.setItem('numberOfQueueColumns', value);

        //GetQueue().then(data => processData(data));
    }


    function changeCell() {

        if (!selectedItem) {
            alert("An item must be selected first.");
            return;
        }

        setChangeCellButtonText("Update...".concat(selectedItem.StudentID));
        setShowInput(true);
        //alert("this function is under development: does not update")
    }

    function onCancelUpdate() {
        setChangeCellButtonText("Update Item");
        setShowInput(false);
    }

    function onSaveUpdate() {
        setChangeCellButtonText("Update Item");
        setShowInput(false);

        apiResults.some(element => {
            if (element.StudentID === selectedItem.StudentID
                && element.InsertDtm === selectedItem.InsertDtm
            ) {
                //console.log(element);
                //alert("Update:" + element.StudentID);
                updateItem(element);
                return true;
            }
        })


        //need a delay as the last record is not updated to DB yet.
        //reload data
        setTimeout(() => {
            GetQueue(organization).then(data => processData(data));
            setRemoveCellButtonText("Remove Item");
        }, 1500); // 1500 milliseconds = 1.5 second
    }

    /*
    function deleteItem(item) {
        item.IsDeleted = true;
        //console.log(item);
        AddQueue(JSON.stringify(item));
    }
    */

    function deleteItem(item) {
        item.IsDeleted = true;
        return AddQueue(JSON.stringify(item)); // return the promise
    }

    function updateItem(item) {
        item.StudentIDUpdate = updateIDValue;

        //this does not work because we changed the id that is used in the lookup
        //item.StudentID = updateIDValue;
        //console.log(item);

        //alert(JSON.stringify(item));
        AddQueue(JSON.stringify(item));

    }

    function processData(results) {
        //console.log("processing...");
        //console.log(results);

        if (testMode) {
            //console.log(apiResults.length);
            if (apiResults.length > 0) {
                results = apiResults;
                //console.log("lenght > 0");
            }
            let now = new Date();
            let isoString = now.toISOString();
            //let newItem = {UserID: isoString};
            let rnd = Math.floor(Math.random() * 100);
            results = results.concat([{ StudentID: rnd.toString(), InsertDtm: isoString }])
        }

        //ensure results is an array in the case of no data retrieved
        results = Array.isArray(results) ? results : [];
        //sort in proper processing order
        //results.sort((a, b) => a.UserID.localeCompare(b.UserID));
        results.sort((a, b) => a.InsertDtm.localeCompare(b.InsertDtm));

        let formattedQ = [];

        let index = 0;


        results.forEach(element => {
            if (element.IsDeleted !== true) {
                element.QueueNum = index;
                //console.log(element);
                index = index + 1;
                if (index === numberOfQueueColumns) {
                    index = 0;
                }
            }
            else {
                element.QueueNum = -1; //ignore
            }
        });


        //console.log(results);

        formattedQ = [].concat(results);
        //formattedQ.sort((a, b) => a.UserID.localeCompare(b.UserID));
        formattedQ = formattedQ.filter(item => item.IsDeleted !== true);

        setApiResults(formattedQ);
        //alert(JSON.stringify(apiResults));

        //console.log("processing end");

        //return results;
    }

    //scroll to top on load
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    useEffect(() => {
        if (!("wakeLock" in navigator)) return;

        const handler = () => {
            navigator.wakeLock.request("screen").catch(console.warn);
        };

        // Delay attaching the listener so scrollTo(0,0) finishes
        const id = setTimeout(() => {
            window.addEventListener("pointerdown", handler, { once: true });
        }, 100); // 50–150ms is enough

        return () => {
            clearTimeout(id);
            window.removeEventListener("pointerdown", handler);
        };
    }, []);


    useEffect(() => {
        let intervalCall;
        let timeoutHandle;

        /*
                const storedValue = localStorage.getItem('numberOfQueueColumns');
                if (storedValue !== null) {
                    setNumberOfQueueColumns(Number(storedValue));
                }
        */

        const fetchData = () => {
            GetQueue(organization)
                .then(data => processData(data));
        };

        const startInterval = () => {
            intervalCall = setInterval(fetchData, refreshMilliseconds);
        };

        const stopInterval = () => {
            if (intervalCall) clearInterval(intervalCall);
        };

        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                fetchData(); // optional immediate refresh
                startInterval();
            } else {
                stopInterval();
            }
        };

        // Initial fetch
        fetchData();

        // Start interval if visible
        if (document.visibilityState === "visible") {
            startInterval();
        }

        // Attach visibility listener
        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Soft timeout after 2 hours
        timeoutHandle = setTimeout(() => {
            stopInterval();
            alert("Dashboard session expired after 2 hours. Please refresh the page to continue.");
            // Optional: show a banner or set a state flag instead of alert
        }, 2 * 60 * 60 * 1000); // 2 hours

        return () => {
            stopInterval();
            clearTimeout(timeoutHandle);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [numberOfQueueColumns, organization, refreshMilliseconds]);

    /*
        useEffect(() => {
            GetQueue()
            .then(data => processData(data));
            return () => {
                //empty
            };
        }, [numberOfQueueColumns]);
    */

    return (
        <div>
            <Link to="/">Home</Link>
            <h3 style={{ marginLeft: 20 }}>
                Queue
                {organization && <span>: {organization} </span>}
            </h3>
            <h3 style={{ marginLeft: 20, marginTop: -30 }}>
                {"Last Sync: " + (currentdate.getMonth() + 1) + "/"
                    + currentdate.getDate() + "/"
                    + currentdate.getFullYear() + " @ "
                    + currentdate.getHours() + ":"
                    + ("0" + currentdate.getMinutes()).slice(-2) + ":"
                    + ("0" + currentdate.getSeconds()).slice(-2)}
                <label style={{ margin: '4px 10px' }}># of Loading Spots:</label>
                <input type="number" name="inputNumberColumns" value={numberOfQueueColumns} style={{ margin: '4px 10px', height: 30, width: 100, fontSize: 20 }} onChange={onNumberColumnsChanged} />
            </h3>

            <div style={{ marginLeft: 20, marginTop: -30 }}>
                <button name="removeRow" style={{ margin: '30px 10px', fontSize: 20 }} onClick={removeRow}>
                    {buttonText}
                </button>

                <button name="removeCell" style={{ margin: '30px 10px', fontSize: 20 }} onClick={removeCell}>
                    {removeCellButtonText} {selectedItem ? selectedItem.StudentID : ''}
                </button>

                <button name="changeCell" style={{ margin: '30px 10px', fontSize: 20 }} onClick={changeCell}>
                    {changeCellButtonText}
                </button>

                {showInput && (
                    <div>
                        <input type="number" name="updateID" style={{ margin: '4px 10px', height: 50, width: 150, fontSize: 40, lineHeight: '50px' }} onChange={updateIDOnChange} />
                        <br></br>
                        <button name="saveUpdate" style={{ margin: '4px 10px', fontSize: 20, backgroundColor: (!updateIDValue || updateIDValue.trim() === '') ? 'gray' : '' }} onClick={onSaveUpdate} disabled={!updateIDValue || updateIDValue.trim() === ''}> Save </button>
                        <button name="cancelUpdate" style={{ margin: '4px 10px', fontSize: 20 }} onClick={onCancelUpdate}> Cancel </button>
                        {(!updateIDValue || updateIDValue.trim() === '') && <p style={{ color: 'red', margin: '4px 10px' }}>Please enter a new Student ID to update.</p>}
                    </div>
                )}
            </div>


            {/*             <div className="column">
                <SingleGrid headerName={"Position 1"} onCellFocused={onCellFocused} gridItems={apiResults.filter(item => item.QueueNum === 0)}></SingleGrid>
            </div>
            <div className="column">
                <SingleGrid headerName={"Position 2"} onCellFocused={onCellFocused} gridItems={apiResults.filter(item => item.QueueNum === 1)}></SingleGrid>
            </div>
            <div className="column">
                <SingleGrid headerName={"Position 3"} onCellFocused={onCellFocused} gridItems={apiResults.filter(item => item.QueueNum === 2)}></SingleGrid>
            </div>
            <div className="column">
                <SingleGrid headerName={"Position 4"} onCellFocused={onCellFocused} gridItems={apiResults.filter(item => item.QueueNum === 3)}></SingleGrid>
            </div>
            <div className="column">
                <SingleGrid headerName={"Position 5"} onCellFocused={onCellFocused} gridItems={apiResults.filter(item => item.QueueNum === 4)}></SingleGrid>
            </div> */}


            <div className="queue-container">
                {Array.from({ length: numberOfQueueColumns }).map((_, i) => (
                    <div className="column" key={i}>
                        <SingleGrid
                            headerName={`Spot ${i + 1}`}
                            onCellFocused={onCellFocused}
                            gridItems={apiResults.filter(item => item.QueueNum === i)}
                            numberOfQueueColumns={numberOfQueueColumns}
                        />
                    </div>
                ))}
            </div>

        </div>
    );
};

export default Queue;